export default __webpack_public_path__ + "static/media/circle.d2b1c1f3.svg";